module.exports = __webpack_public_path__ + "30a324cfbc8f023cf4fbb1b4f0043d24.png";